// extracted by mini-css-extract-plugin
export var cartIcon = "_o5-0";
export var cartIconContainer = "_o5-1";